<template>
    <b-container fluid>
    <div v-if="noOrders">
    <h1 class="mt-4 mb-4" style="padding-top:30px;">You have no Open Orders!  </h1>
        <p>To create a new order, click ADD ORDER.  You can then SEND a text message to your customer when their item is ready and close the order after pickup.</p>
    <p>To change your notification message or other settings, click ADMIN ACCESS and enter your PIN. </p>

<!-- <router-link to="/add-order">Add order</router-link> -->
<div style="padding-top:20px;">
        <router-link to="/add-order"><b-btn class="btn-red">Add Order</b-btn></router-link>
</div>
    </div>

<div v-if="items.length>0">
    <h1 class="mt-4 mb-4">Open Orders</h1>
    <b-row class="add-order" align-h="end" align-v="center">
        <b-col cols="4" sm="3" md="2">
            <router-link to="/add-order"><b-btn class="btn-red">Add Order</b-btn></router-link>
        </b-col>
    </b-row>

        <Table v-if="items.length>0" :items="items" :fields="fields" :hasEditButton="true" :hasCloseButton="true" :hasDeleteButton="true"/>

        <loader v-else :class="{ hidden: noOrders }" />
        </div>

  </b-container>
</template>

<script>
import Loader from "../../components/Loader"
import { db } from '@/main'
import firebase from 'firebase'
import axios from 'axios'
import Table from "@/components/Table.vue";
export default {
    components: {
        Table,
        Loader
    },
    data() {
        return {
            items: [],
            fields: [
                { key: 'startTime', sortable: true },
                { key: 'customer', sortable: true },
                { key: 'tags', sortable: true },
                { key: 'note', sortable: false },
                { key: 'status', sortable: true },
                { key: 'notifiedTime', sortable: true },
                { key: 'notify', sortable: false },
                { key: 'options', sortable: false },
            ],
            sendNotificationApi: 'https://us-central1-readytextme.cloudfunctions.net/orderNotification',
            noOrders: false,
            business: ''
        }
    },
    async created() {
        var vueInstance = this;
        const userDoc = await db.collection('users').doc(firebase.auth().currentUser.uid).onSnapshot(async(doc) => {

            const business = doc.data().business;
            const plan = doc.data().plan;
            const trialVar = doc.data().trialTextsFinished;
            if ((trialVar ==1) && (plan == 'trial')) {
                vueInstance.$router.push({path: '/subscription'});
            }


            // console.log(plan);

            // get open orders
            const snapshot = await db.collection('businesses').doc(business).collection('orders').where('orderObj.status', '>=', 'open')
            .onSnapshot(querySnapshot => {
                const openArray = querySnapshot.docs.map(doc => doc.data().orderObj);
                querySnapshot.forEach(doc => {
                })
                for (let i = 0; i < openArray.length; i++) {
                    let orderObj = openArray[i]
                    orderObj.notify = "Send";
                }
                this.items = openArray;
                if (this.items.length==0) {
                    this.noOrders = true;
                }
            });
        });
    },

    methods: {

    },
}
</script>

<style scoped>
.add-order {
    padding-bottom: 20px;
}

.hidden {
  visibility: hidden !important;
  /* transition: all 0.5s ease; */
}

.btn-red {
    background-color: #DA2a2a;
    border: none;
    border-radius: 5px;
}

.btn-red:hover {
    background-color: #d68181;
    /* color: #000000; */
}

</style>
